module.exports = __webpack_public_path__ + "img/9788936456252.1085b7b5.jpg";